export default __webpack_public_path__ + "static/media/alien.aa6a2c78.jpg";